import { Base64 } from 'js-base64'
import startOfToday from 'date-fns/start_of_today'
import reject from 'lodash/reject'
import muster from '@dbk-legacy/muster'
import { variable } from '@dbk-legacy/muster/helpers'
import { getValues, ref } from '@dbk-legacy/muster/utils'
import Guid from '../../../utils/guid'
import isValidJsonString from '../../../utils/is-valid-json-string'
import { ymd } from '../../../utils/date'
import calendar from '../../calendar-modal'
import { PAYMENT_TYPE, VOP_VALIDATE_CODES } from '../../../screens/payments/constant';
import { pipeTxChallenge, pipeSummary, toNumber, pipeTemplate } from './parser'
import { PAYMENTS_PATH, PAYMENT_INTEGRITY_ERROR_CODE, PAYMENT_PATH, PAYMENT_TYPE as PAY_TYPE } from './constant'
import { ROUTES, PAYMENTS_RETURN_CODES, EBANKINGWEBLUX, RM_REGION, EBANKINGWEBUK, RM_REGION_UK, SEPA_IP_STATUS, SEPA_IP_FINAL_STATUSES, SEPA_PAYMENT_TYPE } from '../../../constants'
import envConfig from '../../../../db-env-build';
import { getPaymentDigest } from './payment-utils';
import splitBeneficiaryName from '../../../utils/splitBeneficiaryName';
import { isVopAllowed } from '../../../utils/featureCheck';

const { DASHBOARD, NEW_DOMESTIC, DEBIT_ACCOUNT_LIST } = ROUTES.PAYMENT

export default () =>
  muster()
    .path('payments.initializeTx', {
      call: async ({ req }, { get, set, call }) => {
        await set('reports.transaction.securityAdviceList', []);
        set('payments.isInitializingTx', true)
        set('payments.initializeTxFails', false)

        let paymentType = req.args[0]
        const newDomPaymentType = (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes(PAYMENT_TYPE.domestic) ? PAYMENT_TYPE.domesticuk : paymentType;
        const channel = 'WEB'
        const deviceCode = ''
        const inputs = `${newDomPaymentType}#@#${deviceCode}#@#${channel}`
        const guidStr = Guid()
        const initializeTxUrl = `${PAYMENTS_PATH}.initializeTx["${inputs}"]["${guidStr}"]`
        const [result] = await getValues(get(initializeTxUrl))
        const [psPosId] = await getValues(get('payments.psPosId'))
        let cashAccountList
            isValidJsonString(result)
          .then(data => {
            const isAvaloqAvailable = data ? data.backEndAvailable : false
            if (isAvaloqAvailable) {
              const txToken = data.txToken
              const txRef = data.txRef
              cashAccountList = data.cashAccountList || []
              const currencyList = data.currencyList || []
              const costList = data.costList || []
              const paymentReasonList = data.paymentReasonList || []
              const beneficiaryList = data.beneficiaryList || [];
              const businessDate = data.businessUnitBankDate;
              const transactionLimit = data.transactionLimit;
              const sepaCountryBicIsoCodeList = data.sepaCountryBicIsoCodeList || []
              let defaultCurrency = (envConfig.envConfig !== EBANKINGWEBLUX && envConfig.rmRegion !== RM_REGION) ? currencyList.find(e => e.tech === 'CHF') || currencyList[0] : currencyList.find(e => e.tech === 'EUR') || currencyList[0];
              let  defaultCost = costList.length === 1 ? costList[0] : costList.find(e => e.displayOrder === 1);
              
              if ( (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK)) {
                defaultCurrency = currencyList.find(e => e.tech === 'GBP');
                defaultCost = costList.find(e => e.costType === 'OUR');    //WMCE-48077- To make default Charges to 'OUR' for eBanking-Initiated Payments-UK
                // if(paymentType.includes('domestic')) {
                //   defaultCost = costList.find(e => e.costType === 'SHA');
                // }
              }

              return Promise.all([
                set('payments.debtAcList', cashAccountList),
                set('payments.creditAcList', cashAccountList),
                set('payments.curcyWhiteList', currencyList),
                set('payments.costList', costList),
                set('payments.paymentReasonList', paymentReasonList),
                set('payments.startDate', ymd(businessDate)),
                set('sepaLimit.sepaTransactionLimit', transactionLimit),
                set('payments.businessDate', ymd(businessDate)),
                set('payments.businessDateIniTx', businessDate),
                set('payments.beneficiaryList', beneficiaryList),
                set('payments.selectCreditAccFlag', false),
                set('payments.isModifyFlow', false),
                set('payments.txToken', txToken),
                set('payments.txRef', txRef),
                set('payments.selectedCurrency', defaultCurrency),
                set('payments.selectedCost', defaultCost),
                set('payments.paymentType', paymentType),
                set('payments.versionId',''),
                set('payments.orderId', ''),
                set('payments.sepaCountryBicIsoCodeList', sepaCountryBicIsoCodeList)
              ])
            } else if (data.message) {
              // payments.error.active.webtxn:  EBANK-9491, when there is an existingPendingTx
              // acp.down: EBANK-10475
              return Promise.resolve(set('payments.initializeTxFails', data.message))
            } else {
              return Promise.all([
                set('payments.initializeTxFails', true)
              ])
            }
          })
          .then(async() => {
            set('payments.isInitializingTx', false)
            if (psPosId) {
              const selectedDbtAcc = cashAccountList.find(x => x.psPosId === psPosId)
              if (selectedDbtAcc) {
                set('payments.selectedDebitAcnt', selectedDbtAcc)
                await call('payments.assignDefaultCurrency')
                call('ui.history.push', { pathname: NEW_DOMESTIC })
                set('payments.psPosId', '')
                set('payments.isCashFlow', true)
              } else {
                call('ui.history.push', { pathname: DASHBOARD })
                set('payments.psPosId', '')
                set('payments.isCashFlow', false)
              }
            }
          })
          .catch(() => {
            set('payments.isInitializingTx', false)
            set('payments.initializeTxFails', true)
          })
      },
    })
    .path('payments.validatePayment', {
      call: async ({ req }, { get, set, call }) => {
        set('payments.isValidatingPayment', true)
        let [paymentType] = await getValues(get(['payments.paymentType']));
        let [
          selectedDebitAcnt,
          selectedCurrency,
          amount,
          executionDate,
          selectedCost,
          remarks,
          selectedBeneficiaryBank,
          txToken,
          txRef,
          businessUnitBankDate,
          selectedCreditAcnt,
          orderId,
          versionId,
          externalOrderId,
          isSaveEnabled,
          isPaymentTemplateFlow,
          isSaveModifiedTemplate,
          paymentReason,
          selectedBeneficiaryBankSEPAPaymentType
        ] = await getValues(
          get([
            'payments.selectedDebitAcnt',
            'payments.selectedCurrency',
            'payments.amount',
            'payments.startDate',
            'payments.selectedCost',
            'payments.remarks',
            'payments.selectedBeneficiaryBank',
            'payments.txToken',
            'payments.txRef',
            'payments.businessDateIniTx',
            'payments.selectedCreditAcnt',
            'payments.orderId',
            'payments.versionId',
            'payments.externalOrderId',
            'payments.isSaveEnabled',
            'payments.isPaymentTemplateFlow',
            'payments.saveModifiedTemplate',
            'payments.paymentReason',
            'payments.selectedBeneficiaryBankSEPAPaymentType',
          ])
        )
   
        set('payments.errorMsgs', '')
        set('payments.errorMsgFlag', false)
        set('payments.overrideTemp', null);
        const channel = 'WEB'
        const deviceCode = 'web-' + Guid()
        let templateObj = null;

        if((isSaveEnabled || isSaveModifiedTemplate)){
        const [selectedPaymentTemplate, templateName, userId] = await getValues(
          get(['payments.selectedPaymentTemplate','payments.templateName', 'auth.userId']));

          if(isSaveEnabled && isPaymentTemplateFlow && (selectedPaymentTemplate.templateName !== templateName)){ // WMCE-12403
            selectedPaymentTemplate.templateId = null; // save as new template if checkbox enabled in payment template flow
          }
          templateObj = pipeTemplate({selectedPaymentTemplate, templateName,paymentType, selectedDebitAcnt, selectedCurrency, amount: toNumber(amount), selectedBeneficiaryBank, 
          selectedCreditAcnt, remarks, selectedCost});
          templateObj.userId = userId;
        }
        const template = Base64.encode(JSON.stringify(templateObj));
        
        // const inputs = `${paymentType}#@#${deviceCode}#@#${channel}#@#${txToken}`
        //APT txToken
        paymentType = (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes(PAYMENT_TYPE.domestic) ? PAYMENT_TYPE.domesticuk : paymentType;
        const txToken1 = '';
        //const inputs = `${paymentType}#@#${deviceCode}#@#${channel}#@#${txToken1}#@#${template}`
        const guidStr = Guid();
        if(selectedBeneficiaryBank && selectedBeneficiaryBank.sortCode) {
          selectedBeneficiaryBank.sortCode = selectedBeneficiaryBank.sortCode.replaceAll("-", "");
         }
         if(selectedBeneficiaryBank && selectedBeneficiaryBank.ntnlId) {
          selectedBeneficiaryBank.ntnlId = selectedBeneficiaryBank.ntnlId.replaceAll("-", "");
         }
        // payee
        const to = paymentType.includes('internal') ? selectedCreditAcnt : selectedBeneficiaryBank
        const [enableStructuredAddress] = await getValues(get('app.config.enableStructuredAddress'));
        const challenge = pipeTxChallenge({
          paymentType,
          executionDate,
          amount: toNumber(amount),
          remarks,
          businessUnitBankDate,
          from: selectedDebitAcnt,
          to,
          currency: selectedCurrency,
          cost: selectedCost,
          orderId,
          versionId,
          externalOrderId,
          enableStructuredAddress: Boolean(enableStructuredAddress)
        })
        const chargeDesc = selectedCost ? selectedCost.ebLabelDesc : ''
        const base64 = Base64.encode(JSON.stringify(challenge));
         //----------------------------------------------------------
         const paymentDigest = getPaymentDigest(txRef, challenge , paymentType, Boolean(enableStructuredAddress));
         const standingOrder='';
        const inputs = `${paymentType}#@#${deviceCode}#@#${channel}#@#${txToken1}#@#${paymentDigest}#@#${template}#@#${standingOrder}#@#${paymentReason}#@#${selectedBeneficiaryBankSEPAPaymentType}`;
        const geneTxChallengeUrl = `${PAYMENTS_PATH}.generateTxChallenge["${base64}"]["${inputs}"]["${guidStr}"]`
        let oReturn, oReturnVopVal;
        const [ isVopEnabled ] = await getValues(get('app.config.isVopEnabled'));
        const vopAllowed = isVopAllowed(isVopEnabled, paymentType);
        if(vopAllowed) {
          const vopValReqParam = {
            channel,
            deviceCode,
            txToken,
            psPosId: selectedDebitAcnt && selectedDebitAcnt.psPosId,
            beneficiaryId: selectedBeneficiaryBank && selectedBeneficiaryBank.beneficiaryId,
          }
          const vopValReqParamEncoded = Base64.encode(JSON.stringify(vopValReqParam)); 
          [oReturn, oReturnVopVal]= await getValues(get([geneTxChallengeUrl,
            `${PAYMENT_PATH}.paymentsBenValidate["${vopValReqParamEncoded}"]["${guidStr}"]`
          ]));
          isValidJsonString(oReturnVopVal)
            .then( async (data) => {
              if(!data.errorCode) {
                await set('payments.vopValVerCode', data.verificationCode);
                if(data.verificationCode === VOP_VALIDATE_CODES.CLOSED_MATCH) {
                  await set('payments.vopValPayeeName', data.payeeName);
                  await set('payments.vopValTxToken', data.txToken);
                }
              } else {
                await set('payments.vopValVerCode', VOP_VALIDATE_CODES.VER_FAILED);
              }
            })
            .catch( async () => {
              await set('payments.vopValVerCode', VOP_VALIDATE_CODES.VER_FAILED);
            })
        } 
        else {
          [oReturn] = await getValues(get(geneTxChallengeUrl));
        }

        const [templateName] = await getValues(get('payments.templateName'))
        const oReturnDATA = JSON.parse(oReturn)
        isValidJsonString(oReturn)
          .then(async data => {
            if((isSaveEnabled || isSaveModifiedTemplate)){
            await set('payments.isSaveEnabled', true);
            }
            const tx = pipeSummary({ paymentType, challenge, data, txToken, chargeDesc, externalOrderId })
            await set('payments.selectedBeneficiaryBankSEPAPaymentType', data?.txExecType);
            set('payments.validatePaymentStatus', 'submitted')
            set('payments.transreqKey', data.requestKey)
            if (data.dwoMessage.messages) {
              // blocking errors
              const error = data.dwoMessage.messages
              set('payments.errorMsgs', error)
              set('payments.errorMsgFlag', true)

              if(data.dwoMessage.messages.find(item => item.errorCode === PAYMENTS_RETURN_CODES.TEMPLATE_EXIST)){
                // Fix for WMCE-12688
                await call('payments.getTemplateList');
                const [templateList] = await getValues(get('payments.templateList'));
                const overridExistingTemp = templateList.filter(e => e.templateName === templateName)[0];
                await set('payments.overrideTemp', overridExistingTemp);
              }
            }
            return tx
          })
          .then(tx => {
            set('payments.isValidatingPayment', false)
            // todo if changePage, add logic here
            set('payments.currentTx', tx)
          })
          .catch(async() => {
            set('payments.isValidatingPayment', false)
            set('payments.initializeTxFails', true)
            // blocking errors
            if(oReturnDATA && oReturnDATA.messageType && oReturnDATA.messageType === "ERROR" && oReturnDATA.errorCode && oReturnDATA.errorCode === PAYMENT_INTEGRITY_ERROR_CODE){
              await set ('payments.isRequestInvalid',true);  // WMCE-42026-- APT fix WMLU-02 Lack of data validation - Payments Request Submission Flow
              const [messages] = await getValues(get('i18n.messages'));
              await  set('payments.errorMsgs', [{errorDesc: messages['app.payments.dataIntegrity.errorMessage']}])
            } else if(oReturnDATA && oReturnDATA.messageType && (oReturnDATA.messageType === "ERROR" )){
              await  set('payments.errorMsgs', [{errorDesc: oReturnDATA?.message}])
            }
            else if(oReturnDATA && oReturnDATA.dwoMessage && oReturnDATA.dwoMessage.messages){
              set('payments.errorMsgs', oReturnDATA.dwoMessage.messages)
            }
          })
      },
    })
    .path('payments.onCalendarDone', {
      call: async ({ req }, { get, set, call }) => {
        const startDate = req.args[0].fromDate || req.args[0].toDate
        if (startDate) set('payments.startDate', ymd(startDate))
      },
    })
    .path('payments.resetForm', {
      call: async ({ req }, { get, set, call }) => {
        const [curcyWhiteList] = await getValues(get('payments.curcyWhiteList'))
        const defaultCurrency = curcyWhiteList && curcyWhiteList.find(e => e.tech === 'CHF')
        const [costList] = await getValues(get('payments.costList'))
        const defaultCost = costList && costList.find(e => e.displayOrder === 1)
        let businessDate = await getValues(get('payments.businessDate'))
        if (!businessDate[0]) businessDate = startOfToday()

        set('payments.filterFlag', false)
        set('payments.creditAcList', [])
        set('payments.selectedCurrency', defaultCurrency)
        set('payments.selectedCost', defaultCost)
        set('payments.amount', '')
        set('payments.remarks', '')
        set('payments.startDate', ymd(businessDate))
        set('payments.selectedBeneficiaryBank', null)
        set('payments.selectedCreditAcnt', null)
        set('payments.selectedDebitAcnt', null)
        set('payments.selectCreditAccFlag', false)
        set('payments.errorMsgs', '')
        set('payments.isCashFlow', false)
        set('payments.errorMsgFlag', false)
        set('payments.isPymtAddNewBenef', false)
        set('payments.externalOrderId','')
        await set('payments.refreshStatus', {})
        await set ('payments.isRequestInvalid',false);
      },
    })
    .path('payments.verifyChallengeResponse', {
      call: async ({ req }, { get, set, call }) => {
        let paymentType = await getValues(get('payments.paymentType'))
        const [currentTx] =await getValues(get('payments.currentTx'));
        const uuid = currentTx.uuid;
        const modifiedTs = currentTx.modifiedTs;
        const channel = 'WEB'
        const [txToken] = await getValues(get('payments.txToken'))
        await set('transactions.verifyChallengeResponseValue', '')
        await set('payments.isRequestInvalid',false)
        const tdsSingnature = req.args[0] || 'web-' + Guid()
        const [requestKey] = await getValues(get('payments.transreqKey'))
        const guidStr = Guid()
        const [deviceCode] = await getValues(get('device.uniqueId'))
        paymentType = (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes(PAYMENT_TYPE.domestic) ? PAYMENT_TYPE.domesticuk : paymentType;
        //APt txToken
        const input = `${paymentType}#@@@#${channel}#@@@#${deviceCode}#@@@##@@@#${tdsSingnature}#@@@#${requestKey}#@@@#${guidStr}#@@@#${uuid}#@@@#${modifiedTs}`   // Wmce-35439-- APT fix by introducing uuid and modifiedTs
        // const input = `${paymentType}#@@@#${channel}#@@@#${deviceCode}#@@@#${txToken}#@@@#${tdsSingnature}#@@@#${requestKey}#@@@#${guidStr}`

        
        const [oReturn] = await getValues(
          get(`${PAYMENTS_PATH}.verifyChallengeResponse["${input}"]`)
        )
          isValidJsonString(oReturn)
          .then(async data => {
            if (data.returnCode == 134) {
             await set ('payments.isRequestInvalid',true);  //Wmce-35439-- APT fix by introducing uuid and modifiedTs. Handling return code 134 for mismatched uuid and modifiedTs
            }
           if (data.webTxnTimeOut) {
              // EBANK-15212 - Change Transaction Timeout for Payments to 5 min
              await set('payments.webTxnTimeout', Number(data.webTxnTimeOut)||5)
            }
           await set('transactions.verifyChallengeResponseValue', data)
           await set('payments.isPymtAddNewBenef',false)
            return null
          })
        .catch(() => {})
              },
    })
    .path('payments.assignDefaultCurrency', {
      call: async ({ req }, { get, set, call }) => {
        const [paymentType] = await getValues(get('payments.paymentType'))
        const [selectedDebitAcnt] = await getValues(get('payments.selectedDebitAcnt'))
        const [curcyWhiteList] = await getValues(get('payments.curcyWhiteList'))

        let defaultCurrencyCode
        if (paymentType.includes('interna')) {
          defaultCurrencyCode = selectedDebitAcnt.currency
        } else if (paymentType.includes('domestic')) {
          defaultCurrencyCode = 'CHF'
        } else if (paymentType.includes('sepa')) {
          defaultCurrencyCode = 'EUR'
        }
        let defaultCurrency = curcyWhiteList.find(e => e.tech === defaultCurrencyCode);

        if ((envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK)) {
          defaultCurrency = curcyWhiteList.find(e => e.tech === 'GBP');
        }
        set('payments.selectedCurrency', defaultCurrency);
      },
    })
    .path('payments.loadDebitAccountList', {
      call: async ({ req }, { get, set, call }) => {
         set('payments.selectCreditAccFlag', false)
        const [selectedCreditAcnt] = await getValues(get('payments.selectedCreditAcnt'))
        const [creditAcList] = await getValues(get('payments.creditAcList')) 
        const debtAcList = reject(creditAcList, selectedCreditAcnt)
        await set('payments.debtAcList', debtAcList)
        await call('ui.history.push', { pathname: DEBIT_ACCOUNT_LIST })
      },
    })
    .path('payments.loadCreditAccountList', {
      call: async ({ req }, { get, set, call }) => {
        set('payments.selectCreditAccFlag', true)
        await call('ui.history.push', { pathname: DEBIT_ACCOUNT_LIST })
      },
    })
    .path('payments.refreshPayments', {
      call: async ({ req }, { get, set, call }) => {
        set('payments.debtAcList', [])
        set('payments.isDebitAcnt', false)
        set('payments.beneficiaryList', [])
        set('payments.costList', [])
        set('payments.paymentReasonList', [])
        set('payments.creditAcList', [])
        set('payments.selectedCreditAcnt', null)
        set('payments.selectedDebitAcnt', null)
        set('payments.isIBANSelected', true)
        set('payments.errorIBANMsg', '')
        set('payments.countryList', [])
        set('payments.bankList', [])
        set('payments.selectedBeneficiaryBank', null)
        set('payments.selectedBank', null)
        set('transactions.verifyChallengeResponseValue', '')
        set('payments.amount', '')
        set('payments.isPymtAddNewBenef', false)
        set('payments.externalOrderId','')
        set('payments.remarks', '')
        set('payments.selectedBeneficiaryBankSEPAPaymentType', SEPA_PAYMENT_TYPE.CLASSIC)
        set('payments.paymentReason','')
        set('payments.selectedBeneficiaryDetail',null)
      },
    })

    .path('payments.beneficiariesNamesPatch', {
      call: async ( { req }, { get, set, call }) => {
        await set('payments.isBenNamesPatching', true);
        const channel = 'WEB';
        const deviceCode = 'web-' + Guid();
        const [txToken, selectedBeneficiaryBank] = await getValues(get(['payments.vopValTxToken', 'payments.selectedBeneficiaryBank']));
        const vopPatchReqParam = {
          channel,
          deviceCode,
          txToken,
          beneficiaryId: selectedBeneficiaryBank && selectedBeneficiaryBank.beneficiaryId,
        }
        const vopPatchReqParamEncoded = Base64.encode(JSON.stringify(vopPatchReqParam));
        const guidStr = Guid();
        const [ oReturnVopPatch ] = await getValues(get(`${PAYMENT_PATH}.beneficiariesNamesPatch["${vopPatchReqParamEncoded}"]["${guidStr}"]`));
        
        isValidJsonString(oReturnVopPatch)
          .then( async (data) => {
            if(!data.errorCode) {
              const [ firstName, lastName ] = splitBeneficiaryName(data.payeeName);
              const updatedSelectedBenBank = { ...selectedBeneficiaryBank, firstName, lastName, beneficiaryName: data.payeeName };
              await set('payments.selectedBeneficiaryBank', updatedSelectedBenBank);
              await call('payments.validatePayment');
              await set('payments.isVopPatchSucceed', true);
              await set('payments.isBenNamesPatching', false);
              await set('payments.isVopPatchFailed', false);
            } else  {
              await set('payments.isVopPatchFailed', true);
            }
            await set('payments.isBenNamesPatching', false);
          })
          .catch( async () => {
            await set('payments.isVopPatchFailed', true);
            await set('payments.isBenNamesPatching', false);
            await set('payments.isVopPatchSucceed', false);
          })
      }
    })
    // muster path to get the status of SEPA IP payment
    .path('payments.getSepaIpPaymentStatus', {
      call: async ( { req }, { get, set, call }) => {
        await set('payments.isSepaIpStatusFetching', true);
        await set('payments.sepaIpPaymentStatusData', null);
        await set('payments.sepaIpIntermediateStatusData', null);
        const channel = 'WEB';
        const deviceCode = Guid();
        const [txToken] = await getValues(get(['payments.txToken']));
        const sepaIpStatusBody = {
          channel,
          deviceCode,
          txToken,
        }

        const MAX_POLL_ATTEMPTS = 6;
        const POLL_INTERVAL_MS = 3000;
        const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

        const fetchStatus = async () => {
          const guidStr = Guid();
          const randomStr = "random" + Math.round(Math.random() * 1000);
          //To force each
          // polling attempt to actually hit the backend, embed a per-attempt nonce inside
          // the encoded body so the memoizer key differs. The nonce field is ignored by
          // the api-factory when it builds the outbound request body.
          const perAttemptBody = { ...sepaIpStatusBody, _nonce: `${guidStr}-${randomStr}` };
          const sepaIpStatusBodyEncoded = Base64.encode(JSON.stringify(perAttemptBody));
          const [ oReturn ] = await getValues(get(
            `${PAYMENT_PATH}.sepaIpPaymentStatus["${sepaIpStatusBodyEncoded}"]["${guidStr}"]["${randomStr}"]`
          ));
          try {
            return await isValidJsonString(oReturn);
          } catch (e) {
            return null;
          }
        }

        // Poll until a final status ('COMPLETED', 'REJECTED', 'ERROR', 'TIMEOUT') is received
        // or the max attempts is done.
        //  Intermediate statuses ('ACCEPTED', 'IN_PROGRESS') then polling to continue.
        //  When status is 'ACCEPTED', publish it as intermediate data so the UI
        //  can render a "Payment Accepted" screen while polling continues.
        let finalData = null;
        for (let attempt = 0; attempt < MAX_POLL_ATTEMPTS; attempt++) {
          if (attempt > 0) {
            await sleep(POLL_INTERVAL_MS);
          }
          const data = await fetchStatus();
          if (data && !data.errorCode && SEPA_IP_FINAL_STATUSES.includes(data.paymentStatusCode)) {
            finalData = data;
            break;
          }
          if (data && !data.errorCode && data.paymentStatusCode === SEPA_IP_STATUS.ACCEPTED) {
            await set('payments.sepaIpIntermediateStatusData', data);
          }
        }

        // If polling exhausted without reaching a backend-provided final status, treat as TIMEOUT
        if (!finalData) {
          finalData = { paymentStatusCode: SEPA_IP_STATUS.TIMEOUT };
        }

        await set('payments.sepaIpPaymentStatusData', finalData);
        await set('payments.sepaIpIntermediateStatusData', null);
        await set('payments.isSepaIpStatusFetching', false);
      }
    })

    .path('payments.webTxnTimeout', variable(5)) // EBANK-15212 - Change Transaction Timeout for Payments to 5 min
    .path('payments.transreqKey', variable(''))
    .path('payments.subscription', variable(true)) //! never used
    .path('payments.createNewModal', variable(false))
    .path('payments.debtAcList', variable(false))
    .path('payments.isDebitAcnt', variable(false))
    .path('payments.selectedDebitAcnt', variable(null))
    .path('payments.curcyWhiteList', variable(null))
    .path('payments.beneficiaryList', variable(false))
    .path('payments.startDate', variable(null))
    .path('payments.selectedCurrency', variable(null))
    .path('payments.setDebitAccountFlow', variable(null))
    .path('payments.amount', variable(''))
    .path('payments.remarks', variable(''))
    .path('payments.txToken', variable(''))
    .path('payments.txRef', variable(''))
    .path('payments.selectedCost', variable(null))
    .path('payments.costList', variable({}))
    .path('payments.paymentReasonList', variable({}))

    .path('payments.businessDate', variable(null))
    .path('payments.businessDateIniTx', variable(null))
    .path('payments.psPosId', variable(''))
    .path('payments.summaryObject', variable(''))
    .path('payments.errorMsgs', variable(''))
    .path('payments.validatePaymentStatus', variable(''))
    .path('payments.errorMsgFlag', variable(false))
    .path('payments.paymentType', variable(''))
    .path('payments.isModifyFlow', variable(false))
    .path('payments.selectCreditAccFlag', variable(false))
    .path('payments.creditAcList', variable([]))
    .path('payments.isCashFlow',variable(false))
    .path('payments.isCashPaymentFlow',variable(false))
    .path('payments.isRequestInvalid',variable(false))
    .path('payments.selectedCreditAcnt', variable(null))
    .path('payments.isModifyDebitAcnt', variable(false))
    .path('payments.paymentReason', variable(''))
    // loadings
    .path('payments.initializeTxFails', variable(false))
    .path('payments.isValidatingPayment', variable(false))
    .path('payments.isInitializingTx', variable(false))
    // status
    .path('payments.toggleConfirmModal', variable(false))
    .path('payments.sepaCountryBicIsoCodeList', variable(''))
    .path('payments.vopValVerCode', variable(null))
    .path('payments.vopValPayeeName', variable(null))
    .path('payments.isBenNamesPatching', variable(false))
    .path('payments.vopValTxToken', variable(null))
    .path('payments.isVopPatchFailed', variable(false))
    .path('payments.isVopPatchSucceed', variable(false))
    .path('payments.isSepaIpStatusFetching', variable(false))
    .path('payments.sepaIpPaymentStatusData', variable(null))
    .path('payments.sepaIpIntermediateStatusData', variable(null))
    .path('payments.resetVoPGlobals', {
      call: async ( {}, { set } ) => {
        await set('payments.vopValVerCode', null);
        await set('payments.vopValPayeeName', null);
        await set('payments.isBenNamesPatching', false);
        await set('payments.vopValTxToken', null);
        await set('payments.isVopPatchFailed', false);
        await set('payments.isVopPatchSucceed', false);
      }
    })

    .import('payments.calendar', calendar(), {
      onDone: ref('payments.onCalendarDone'),
    })
